import ac from 'argument-contracts';
import { EXTERNAL_NAME } from '../external-name';

function buildTagNameFromTaggedTemplateLiteral(strings, ...values) {
    let tagName = '';

    strings.forEach((string, index) => {
        tagName += string + (values[index] || '');
    });

    return tagName;
}

/**
 * A function to generate prefixed tag names for the applet element
 *
 * @private
 * @param {string|string[]} tagName - The tag name to prefix
 * @param {any[]} values - The values from the tagged template string
 * @returns {string} - The prefixed tag name
 */
export function generatePrefixedTagName(tagName, ...values) {
    if (!tagName) {
        throw new Error('tagName must be provided in order to generate a prefixedTagName');
    }

    let safeTagName;

    if (Array.isArray(tagName)) {
        ac.assertArrayOf(tagName, String, 'tagName');
        safeTagName = buildTagNameFromTaggedTemplateLiteral(tagName, ...values);
    } else {
        ac.assertString(tagName, 'tagName');
        safeTagName = tagName;
    }

    return `${EXTERNAL_NAME}-${safeTagName}`.toLowerCase();
}